function ViewEmailIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="1.5"
        y="1.5"
        width="21"
        height="15"
        rx="2"
        fill="#4079F5"
        stroke="#FFFFFF"
        strokeWidth="1"
      />
      <path
        d="M2.4 3.6l9.6 7 9.6-7"
        stroke="#FFFFFF"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}

export default ViewEmailIcon
